import Announcement from '@mui/icons-material/Announcement';
import { makeObservable, observable } from 'mobx';
import Dominios from '../../util/Dominios';
import { Filtro } from './Filtro';

export default class FiltroVotacaoComRessalva extends Filtro {
    tipo = 'booleano';
    exibicao = 'checkbox';

    get label() {
        return 'Votação com pelo menos 1 ressalva';
    }

    getIconeFiltroRapido() {
        return <Announcement />;
    }

    filtroRapido = {
        valor: true
    };

    constructor(props) {
        super(props);

        makeObservable(this, {
            filtroRapido: observable
        });
    }

    getValorOpcao(registro) {
        return (
            registro.votos &&
            registro.votos.findIndex((voto) => voto.voto?.codigo === Dominios.CODIGO_VOTO_RESSALVA) !== -1
        );
    }

    getDescricao(valor) {
        return this.labelBooleanoSimNao(valor);
    }
}
